// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Tag, isMarkdocAstTag} from 'docs/util';
import {formatLanguage} from 'docs/util/formatLanguage';

export const CodeTab: MarkdocTagRegistration = {
  tag: 'code-tab',
  component: 'CodeTab',
  attributes: {
    title: {type: String, required: true, localizable: true},
    id: {type: String, required: true},
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    if (
      children.length === 1 &&
      isMarkdocAstTag(children[0]) &&
      children[0].attributes.language
    ) {
      // If we have a single CodeBlock in a CodeTab we can infer the ID and title by language
      if (!attributes.id) {
        attributes.id = children[0].attributes.language;
      }
      if (!attributes.title) {
        attributes.title = formatLanguage.fromPrismValue(
          children[0].attributes.language,
        );
      }
    }

    return new Tag(this.tag, {...attributes}, children);
  },
};
